import React, { useEffect } from 'react';
import { Provider } from 'react-redux';
import { store } from './redux/store';
import Router from './Router/Router';
import { ThemeProvider } from 'styled-components';
import { theme } from 'src/styles/themeStyles';
import { validateSession } from './helpers/validateSession';

function App() {

    useEffect(() => {
        if (typeof window !== 'undefined') {
            validateSession();
        }
    }, []);

    return (
        <Provider store={store}>
            <ThemeProvider theme={theme}>
                <Router />
            </ThemeProvider>
        </Provider>
    );
}

export default App;
